import { lazyWithRetries } from '@globals/lazyWithRetries'
import AppPaths from '@globals/paths'
import CenteredBoxLayout from '@layouts/CenteredBoxLayout'
import RouteLoading from '@shared/routing/RouteLoading'
import { Suspense } from 'react'
import { RouteObject } from 'react-router'

const PasswordRecoveryRoute = lazyWithRetries(() => import('./login/passwordRecovery'))
const PasswordResetRoute = lazyWithRetries(() => import('./login/passwordReset'))
const LinkExpiredRoute = lazyWithRetries(() => import('./login/linkExpired'))
const LoginRoute = lazyWithRetries(() => import('./login'))
const PasswordExpiredRoute = lazyWithRetries(() => import('./login/passwordExpired'))
const PasswordSetupRoute = lazyWithRetries(() => import('./login/passwordSetup'))

const routes: RouteObject[] = [
  {
    path: AppPaths.anon.userLogin(),
    element: (
      <Suspense fallback={<RouteLoading />}>
        <LoginRoute />
      </Suspense>
    ),
  },
  {
    path: AppPaths.anon.passwordRecovery(),
    element: (
      <CenteredBoxLayout>
        <Suspense fallback={<RouteLoading />}>
          <PasswordRecoveryRoute />
        </Suspense>
      </CenteredBoxLayout>
    ),
  },
  {
    path: AppPaths.anon.resetPassword(),
    element: (
      <CenteredBoxLayout>
        <Suspense fallback={<RouteLoading />}>
          <PasswordResetRoute />
        </Suspense>
      </CenteredBoxLayout>
    ),
  },
  {
    path: AppPaths.anon.linkExpired(),
    element: (
      <CenteredBoxLayout>
        <Suspense fallback={<RouteLoading />}>
          <LinkExpiredRoute />
        </Suspense>
      </CenteredBoxLayout>
    ),
  },
  {
    path: AppPaths.anon.passwordExpired(),
    element: (
      <CenteredBoxLayout>
        <Suspense fallback={<RouteLoading />}>
          <PasswordExpiredRoute />
        </Suspense>
      </CenteredBoxLayout>
    ),
  },
  {
    path: AppPaths.anon.passwordSetup(),
    element: (
      <CenteredBoxLayout>
        <Suspense fallback={<RouteLoading />}>
          <PasswordSetupRoute />
        </Suspense>
      </CenteredBoxLayout>
    ),
  },
]

export default routes
